<odl-popover
  #searchPopover
  [open]="open()"
  (odl-open)="onOpen()"
  (odl-close)="onClose()"
  class="search-popover"
  [class.dragging]="isDragging()"
  [attr.for]="popoverFor()"
  placement="bottom-start"
>
  <div class="search-wrapper" #searchWrapper id="search-bar-container">
    <div class="search-wrapper__drag-indicator" #dragHandle (pointerdown)="dragStart($event)">
      <odl-icon name="drag_indicator" slot="only-icon"></odl-icon>
    </div>
    <odl-input
      #searchInput
      class="search-wrapper__input"
      [class.reduced]="searchResults.hasValue()"
      inputmode="text"
      autofocus
      [value]="textToSearch()"
      (keydown.enter)="searchText($any($event.target).value)"
    >
      @if (errorKey(); as errorKey) {
        <span slot="error">{{ errorKey | translate: { count: minCharsToSearch() } }}</span>
      }
    </odl-input>

    @if (searchResults.value()?.length) {
      <button
        id="results-trigger"
        class="search-wrapper__results"
        tabindex="0"
        (click)="toggleResultsModal()"
      >
        <span class="search-wrapper__results-count">
          {{ showSearchIndex() }} / {{ totalSearchResults() }}
        </span>
        <odl-icon
          class="search-wrapper__results-icon"
          name="expand_more"
          [class.rotated]="resultsModalOpened()"
        ></odl-icon>
      </button>
      <odl-popover
        [attr.for]="'#results-trigger'"
        autoupdate
        #resultsPopover
        placement="bottom"
        [open]="resultsModalOpened()"
        distance="4"
        stretch
        reference="#search-bar-container"
      >
        <nr-search-results
          (toggleShowResults)="toggleResultsModal()"
          [index]="showSearchIndex() - 1"
        ></nr-search-results>
      </odl-popover>
    }

    <odl-divider class="search-wrapper__divider" vertical></odl-divider>

    <odl-button
      id="search-bar-previous-result"
      class="search-wrapper__nav-button"
      [description]="'SEARCH_BAR.PREVIOUS_RESULT' | translate"
      (click)="navigateToPreviousResult()"
      [disabled]="!searchResults.hasValue()"
    >
      <odl-icon name="navigate_back" slot="only-icon" />
    </odl-button>

    <odl-button
      id="search-bar-next-result"
      class="search-wrapper__nav-button"
      [description]="'SEARCH_BAR.NEXT_RESULT' | translate"
      (click)="navigateToNextResult()"
      [disabled]="!searchResults.hasValue()"
    >
      <odl-icon name="navigate_next" slot="only-icon" />
    </odl-button>

    <odl-button id="search-bar-close" [description]="'CLOSE' | translate" (click)="close()">
      <odl-icon name="close" slot="only-icon" />
    </odl-button>
  </div>
</odl-popover>

<odl-tooltip for="#search-bar-previous-result">
  {{ 'SEARCH_BAR.PREVIOUS_RESULT' | translate }}
</odl-tooltip>
<odl-tooltip for="#search-bar-next-result">
  {{ 'SEARCH_BAR.NEXT_RESULT' | translate }}
</odl-tooltip>
<odl-tooltip for="#search-bar-close">{{ 'CLOSE' | translate }}</odl-tooltip>
